import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { defaultCountries, parseCountry, PhoneInput, ParsedCountry } from 'react-international-phone';
import { useTranslation } from 'react-i18next';
import { blockedEmailDomainPattern, federatedEmailDomainPattern } from 'utils/emailValidation';
import 'react-international-phone/style.css';

type UserInfoSectionProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  BoundInput: React.ComponentType<any>;
  phone: string;
  isValidPhone: boolean;
  email: string;
  isValidEmail: boolean;
  preferredLanguage: string;
  disabled?: boolean;
  onEmailChange: (value: string) => void;
  onPhoneChange: (phone: string, meta: { country: ParsedCountry; inputValue: string }) => void;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
};

const allowedCountries = defaultCountries.filter((c) => ['no', 'se'].includes(parseCountry(c).iso2));

function UserInfoSection({
  form,
  BoundInput,
  phone,
  isValidPhone,
  email,
  isValidEmail,
  preferredLanguage,
  disabled,
  onEmailChange,
  onPhoneChange,
  onFirstNameChange,
  onLastNameChange
}: UserInfoSectionProps) {
  const { t } = useTranslation('pages');

  return (
    <>
      <Row className='mb-2'>
        <Col sm={12}>
          <h3>{t('createUser.userInfoTitle')}</h3>
        </Col>
      </Row>
      <Row className='mb-2'>
        <Col lg={6}>
          <BoundInput
            form={form}
            name='firstName'
            label={t('createUser.user.form.firstNameLabel')}
            onChange={onFirstNameChange}
          />
        </Col>
        <Col lg={6}>
          <BoundInput
            form={form}
            name='lastName'
            label={t('createUser.user.form.lastNameLabel')}
            onChange={onLastNameChange}
          />
        </Col>
      </Row>
      <Row className='mb-2'>
        <Col lg={6}>
          <BoundInput
            form={form}
            name='email'
            label={t('createUser.user.form.emailLabel')}
            onChange={onEmailChange}
          />
          {email && !isValidEmail && blockedEmailDomainPattern.test(email) && (
            <div className='text-error'>{t('createUser.user.form.emailBlockedDomainValidationMessage')}</div>
          )}
          {federatedEmailDomainPattern.test(email) && (
            <div className='text-error'>{t('createUser.user.form.emailFederatedDomainValidationMessage')}</div>
          )}
        </Col>
        <Col lg={6}>
          <div className='my-2'>
            <div className='d-block mb-2 lh-1'>{t('createUser.user.form.phoneLabel')}</div>
            {!isValidPhone && (
              <div className='text-error'>{t('createUser.user.form.phoneValidationMessage')}</div>
            )}
            <PhoneInput
              defaultCountry={preferredLanguage === 'Swedish' ? 'se' : 'no'}
              forceDialCode={true}
              countries={allowedCountries}
              disabled={disabled}
              inputStyle={{ borderRadius: '0px', border: '1px solid #8A8A8A', height: '44px', width: '100%' }}
              countrySelectorStyleProps={{
                buttonStyle: { height: '44px', borderRadius: '0px', border: '1px solid #8A8A8A' }
              }}
              value={phone}
              onChange={onPhoneChange}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}

export default UserInfoSection;
